// 国际化配置
import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import LanguageDetector from 'i18next-browser-languagedetector';

// 导入语言资源
import translationZhTW from './locales/zh-TW/translation.json';
import gameZhTW from './locales/zh-TW/game.json';
import walletZhTW from './locales/zh-TW/wallet.json';

import translationEn from './locales/en/translation.json';
import gameEn from './locales/en/game.json';
import walletEn from './locales/en/wallet.json';

import translationPt from './locales/pt/translation.json';
import gamePt from './locales/pt/game.json';
import walletPt from './locales/pt/wallet.json';

i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    fallbackLng: 'zh-TW',
    defaultNS: 'translation',
    ns: ['translation', 'game', 'wallet'],
    debug: process.env.NODE_ENV === 'development',
    interpolation: {
      escapeValue: false,
    },
    detection: {
      order: ['localStorage', 'navigator', 'htmlTag'],
      caches: ['localStorage'],
    },
    resources: {
      'zh-TW': {
        translation: translationZhTW,
        game: gameZhTW,
        wallet: walletZhTW,
      },
      'en': {
        translation: translationEn,
        game: gameEn,
        wallet: walletEn,
      },
      'pt': {
        translation: translationPt,
        game: gamePt,
        wallet: walletPt,
      },
    },
  });

export default i18n;
